module.exports = __webpack_public_path__ + "static/media/11-1.af9e0a48.png";